import React from 'react';
import PropTypes from 'prop-types';
import OptimizedImage from './OptimizedImage';
const AppsBanner = props => {
  const {
    content: { header = '', body = '', imageUrl = '', title = '' } = {}
  } = props;
  return (
    <section id="appcenter-banner">
      <div className="banner-wrapper">
        <div className="description-container">
          <h2 className="vx_text-3">{header}</h2>
          <p>{body}</p>
        </div>
        <OptimizedImage
          imageUrl={imageUrl}
          className={`banner-image`}
          title={title}
        />
      </div>
    </section>
  );
};

AppsBanner.propTypes = {
  content: PropTypes.object
};

export default AppsBanner;
